import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ko from 'vuetify/lib/locale/ko'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#B81F24'
            },
            dark: {
                primary: '#B81F24'
            }
        }
    },
    lang: {
        locales: {ko},
        current: 'ko'
    }
});
